import { useEffect, useState } from "react";
import styled from "styled-components";
import FlagIcon from "../assets/flag.png";
import Text from "./Text";
import CloseX from "./CloseX";

const MainContainer = styled.div`
  background-color: #b6b6b6;
  padding: 0 150px;
  display: flex;
  flex-direction: column;
`;
const ProgressBarContainer = styled.div`
  background-color: #fff;
  border-radius: 60px;
  width: 93%;
  height: 10px;
  margin: 60px auto;

  display: flex;
  flex-direction: row;
`;

const ProgressBarItem = styled.div`
  background-color: #555555;

  flex: 1;

  &:first-of-type {
    border-top-left-radius: 60px;
    border-bottom-left-radius: 60px;
  }

  &:last-of-type {
    border-top-right-radius: 60px;
    border-bottom-right-radius: 60px;
  }

  &:nth-of-type(odd) {
    background-color: #8d8d8d;
  }
`;

const ProgressionSmallFlagBar = styled.div`
  border-radius: 50%;
  background-color: white;
  border: 8px solid #b6b6b6;

  display: flex;
`;
const ProgressionSmallFlagImage = styled.img`
  width: 30px;
  height: 30px;
  padding: 20px;
  transform: rotate(34deg);
`;

const CircleImage = styled.img`
  width: 130px;
  height: 130px;
  border-radius: 50%;
`;

const QuestionContainer = styled.div`
  margin: 80px 0 180px;
  align-self: left;
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

const AnswersContainers = styled.div`
  display: flex;
  flex-direction: row;
  align-items: strech;
  gap: 80px;
  padding: 0 100px 40px;
  background-color: #d9d9d9;
  border-radius: 10px;
  flex: 1;
  margin: 90px 0;
`;

const AnswerItem = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 100px;
  background-color: #ffffff;
  border-radius: 10px;
  padding: 40px 40px;
  margin-top: -90px;
`;

const Sample = () => {
  const [questions, setQuestions] = useState([]);

  const smallImage =
    "https://images.unsplash.com/photo-1731935923419-53a7994520be?q=80&w=1780&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";

  useEffect(() => {
    async function fetchQuestions() {
      try {
        const res = await fetch(
          "https://jsonplaceholder.typicode.com/comments"
        );
        const data = await res.json();
        setQuestions(data.slice(0, 10));
      } catch (err) {
        throw new Error("Error fetching quiz data");
      }
    }
    fetchQuestions();
  }, []);

  const progressBarLength = questions.length + 1;
  console.log(progressBarLength);

  return (
    <MainContainer>
      <CloseX />
      <ProgressBarContainer>
        {questions.map((_, index) => {
          if (index === Math.floor(questions.length / 2)) {
            return (
              <>
                <div
                  style={{
                    alignSelf: "center",
                    paddingBottom: "3px",
                    marginRight: "-4px",
                    marginLeft: "-4px",
                    zIndex: "2",
                  }}
                >
                  <ProgressionSmallFlagBar>
                    <ProgressionSmallFlagImage src={FlagIcon} />
                  </ProgressionSmallFlagBar>
                </div>
                <ProgressBarItem key={index}> </ProgressBarItem>
              </>
            );
          } else {
            return <ProgressBarItem key={index}> </ProgressBarItem>;
          }
        })}
      </ProgressBarContainer>
      <QuestionContainer>
        {" "}
        <Text
          fontFamily="Alegreya"
          fontSize="20px"
          fontWeight="700"
          lineheight="27px"
        >
          Ερώτηση 1
        </Text>
        <Text
          fontFamily="Manrope"
          fontSize="15px"
          fontWeight="400"
          lineheight="20px"
        >
          Γιατί κατά την εποχή της ενετικής κυριαρχίας το κάστρο ονομάστηκε
          «Castel Tornese»;
        </Text>
      </QuestionContainer>
      <AnswersContainers>
        <AnswerItem>
          <CircleImage alt="" src={smallImage} />
          <Text
            fontFamily="Manrope"
            fontWeight="400"
            fontSize="15px"
            lineheight="20.5px"
          >
            Θεωρούσαν ότι εκεί γινόταν η κοπή των νομισμάτων του πριγκιπάτου της
            Αχαΐας, των λεγομένων «τορνεζίων».
          </Text>
        </AnswerItem>
        <AnswerItem>
          <CircleImage alt="" src={smallImage} />
          <Text
            fontFamily="Manrope"
            fontWeight="400"
            fontSize="15px"
            lineheight="20.5px"
          >
            Κατέλαβε το κάστρο ο πρίγκηπας Tornese.
          </Text>
        </AnswerItem>
        <AnswerItem>
          <CircleImage alt="" src={smallImage} />
          <Text
            fontFamily="Manrope"
            fontWeight="400"
            fontSize="15px"
            lineheight="20.5px"
          >
            Η περιοχή της Αχαίας ονομαζόταν από τους Φράγκους Tornese
          </Text>
        </AnswerItem>
      </AnswersContainers>
    </MainContainer>
  );
};

export default Sample;
